import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';
import { IDirectReport } from './IDirectReport';

@Injectable({
    providedIn: 'root'
})
export class DirectReportsLookupService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    uri = `${environment.apiLocation}/DirectReport`;

    public get(
        role: number,
        activeOnly: boolean = true,
        processId: number = null,
        MyDRsOnly?: boolean
    ): Observable<Array<IDirectReport>> {
        const params = {
            UserRole: role,
            Groups: [],
            ActiveOnly: activeOnly,
            processId: processId,
            MyDRsOnly: MyDRsOnly
        };
        if (!processId) {
            delete params.processId;
        }
        this.log.verbose({
            type: 'DirectReportsLookupService:get',
            uri: this.uri,
            params
        });
        return this.http.post<Array<IDirectReport>>(this.uri, params).pipe(
            map(items => this.mapItems(items)),
            tap(res =>
                this.log.verbose({
                    type: 'DirectReportsLookupService:reponse',
                    res
                })
            )
        );
    }
    private mapItems(items: IDirectReport[]): IDirectReport[] {
        return items.map(item => ({
            ...item,
            id: item.EmployeeListID
        }));
    }
}
